import styled from 'styled-components'
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";

export const HomeCaseStudiesCarouselWrapper = styled.section`
	h2 {
		text-align: center;
		color: ${FlexipageColors.blue1000};
		margin: 0 0 4rem;
		text-wrap: balance;

		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.carousel-container {
		--_slide-gap: 40px;

		position: relative;
		overflow: hidden;
		margin: 0 calc(var(--_slide-gap) / -2);
	}

	.carousel-track {
		display: flex;
		width: 100%;
		cursor: grab;
		touch-action: pan-y; /* Allow vertical scrolling but capture horizontal swipes */
		user-select: none; /* Prevent text selection during swipe */

		@media (prefers-reduced-motion: no-preference) {
			transition: transform 0.4s ease-in-out;
		}

		&.is-swiping {
			cursor: grabbing;
			transition: none;
		}
	}

	.carousel-slide {
		flex: 0 0 100%;
		width: 100%;
		padding-inline: calc(var(--_slide-gap) / 2);
	}

	.carousel-controls {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 20;

		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1rem;
		height: 60px;

		padding-inline: calc(var(--_slide-gap) / 2);

		@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
			position: static;
			gap: 1.5rem;
			height: auto;
			margin-bottom: 1rem;
		}
	}

	.carousel-button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background-color: ${FlexipageColors.blue1000};
		color: white;
		border: 0 none;
		cursor: pointer;
		transition: background-color 0.2s ease;

		&:focus-visible {
			outline: 2px solid ${FlexipageColors.blue1000};
			outline-offset: 2px;
		}

		svg {
			height: 1rem;
			color: inherit;
			flex-shrink: 0;
		}

		&:focus-visible {
			outline: 2px solid ${FlexipageColors.blue1000};
			outline-offset: 2px;
		}

		&:hover:not(:disabled),
		&:focus-visible:not(:disabled) {
			background-color: ${FlexipageColors.blue1200};
		}

		&:disabled {
			border-color: #d1d5db;
			color: #d1d5db;
			cursor: not-allowed;
			opacity: 0.7;
		}

		@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
			width: 44px;
			height: 44px;
		}
	}
`